import { Reducer } from 'redux';

// Types
import { SchedulesMatrixState, SchedulesMatrixTypes } from './types';

const INITIAL_STATE: SchedulesMatrixState = {
  schedulesMatrixList: [],
  schedulesMatrixData: null,
  schedulesMatrixConfigList: [],
  schedulesMatrixConfigData: null,
  tripSchedulesList: [],
  tripSchedulesData: null,
  totalCount: 0,
  error: false,
  loading: false,
  created: false,
};

const reducer: Reducer<SchedulesMatrixState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST SCHEDULES MATRIX
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixList: INITIAL_STATE.schedulesMatrixList,
      };
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixList: action.payload.schedulesMatrixList,
        totalCount: action.payload.totalCount,
      };
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixList: INITIAL_STATE.schedulesMatrixList,
      };

    // CASES GET SCHEDULES MATRIX
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixData: INITIAL_STATE.schedulesMatrixData,
      };
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixData: action.payload.schedulesMatrixData,
      };
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixData: INITIAL_STATE.schedulesMatrixData,
      };

    // CASES CREATE SCHEDULES MATRIX
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixData: INITIAL_STATE.schedulesMatrixData,
      };
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixData: action.payload.schedulesMatrixData,
      };
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixData: INITIAL_STATE.schedulesMatrixData,
      };

    // CASES UPDATE SCHEDULES MATRIX
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixData: action.payload.schedulesMatrixData,
      };
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE SCHEDULES MATRIX
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES LIST SCHEDULES MATRIX CONFIG
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixConfigList: INITIAL_STATE.schedulesMatrixConfigList,
      };
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixConfigList: action.payload.schedulesMatrixConfigList,
        totalCount: action.payload.totalCount,
      };
    case SchedulesMatrixTypes.LIST_SCHEDULES_MATRIX_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixConfigList: INITIAL_STATE.schedulesMatrixConfigList,
      };

    // CASES GET SCHEDULES MATRIX CONFIG
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixConfigData: INITIAL_STATE.schedulesMatrixConfigData,
      };
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixConfigData: action.payload.schedulesMatrixConfigData,
      };
    case SchedulesMatrixTypes.GET_SCHEDULES_MATRIX_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixConfigData: INITIAL_STATE.schedulesMatrixConfigData,
      };

    // CASES CREATE SCHEDULES MATRIX CONFIG
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        schedulesMatrixConfigData: INITIAL_STATE.schedulesMatrixConfigData,
      };
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixConfigData: action.payload.schedulesMatrixConfigData,
        created: true,
      };
    case SchedulesMatrixTypes.CREATE_SCHEDULES_MATRIX_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        schedulesMatrixConfigData: INITIAL_STATE.schedulesMatrixConfigData,
      };

    // CASES UPDATE SCHEDULES MATRIX CONFIG
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        schedulesMatrixConfigData: action.payload.schedulesMatrixConfigData,
      };
    case SchedulesMatrixTypes.UPDATE_SCHEDULES_MATRIX_CONFIG_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE SCHEDULES MATRIX CONFIG
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchedulesMatrixTypes.DELETE_SCHEDULES_MATRIX_CONFIG_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES LIST TRIP SCHEDULES
    case SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripSchedulesList: INITIAL_STATE.tripSchedulesList,
      };
    case SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripSchedulesList: action.payload.tripSchedulesList,
        totalCount: action.payload.totalCount,
      };
    case SchedulesMatrixTypes.LIST_TRIP_SCHEDULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripSchedulesList: INITIAL_STATE.tripSchedulesList,
      };

    // CASES GET TRIP SCHEDULES
    case SchedulesMatrixTypes.GET_TRIP_SCHEDULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripSchedulesData: INITIAL_STATE.tripSchedulesData,
      };
    case SchedulesMatrixTypes.GET_TRIP_SCHEDULES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripSchedulesData: action.payload.tripSchedulesData,
      };
    case SchedulesMatrixTypes.GET_TRIP_SCHEDULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripSchedulesData: INITIAL_STATE.tripSchedulesData,
      };

    // CASES CREATE TRIP SCHEDULES
    case SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tripSchedulesData: INITIAL_STATE.tripSchedulesData,
      };
    case SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripSchedulesData: action.payload.tripSchedulesData,
      };
    case SchedulesMatrixTypes.CREATE_TRIP_SCHEDULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tripSchedulesData: INITIAL_STATE.tripSchedulesData,
      };

    // CASES UPDATE TRIP SCHEDULES
    case SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tripSchedulesData: action.payload.tripSchedulesData,
      };
    case SchedulesMatrixTypes.UPDATE_TRIP_SCHEDULES_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE SCHEDULES MATRIX
    case SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchedulesMatrixTypes.DELETE_TRIP_SCHEDULES_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES TRIP SCHEDULES INFO
    case SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchedulesMatrixTypes.TRIP_SCHEDULES_INFO_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES TRIP SCHEDULES PROFILE RESEVATIONS
    case SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case SchedulesMatrixTypes.TRIP_SCHEDULES_PROFILE_RESEVATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
